// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"77edce11","208":"286616d9","221":"a93d5365","350":"b5248f0d","453":"34258626","503":"ce8f6459","584":"3381d06e","681":"e92fd2e7","803":"9074df1b"}[chunkId] + ".chunk.js";
};